export const isCanadaLocale = locale => locale === 'ca-ca';
export const isCzechLocale = locale => locale === 'cs-cs';
export const isAustriaLocale = locale => locale === 'de-at';
export const isGermanyLocale = locale => locale === 'de-de';
export const isEnglandLocale = locale => locale === 'en-gb';
export const isIcelandLocale = locale => locale === 'en-is';
export const isMaltaLocale = locale => locale === 'en-mt';
export const isSloveniaLocale = locale => locale === 'en-si';
export const isLuxembourgLocale = locale => locale === 'en-lu';
export const isMauritiusLocale = locale => locale === 'en-mu';
export const isNewZealandLocale = locale => locale === 'en-nz';
export const isSpainLocale = locale => locale === 'es-es';
export const isFinlandLocale = locale => locale === 'fi-fi';
export const isFranceLocale = locale => locale === 'fr-fr';
export const isHungaryLocale = locale => locale === 'hu-hu';
export const isIrelandLocale = locale => locale === 'ie-ie';
export const isItalyLocale = locale => locale === 'it-it';
export const isJapanLocale = locale => locale === 'ja-jp';
export const isPolandLocale = locale => locale === 'pl-pl';
export const isPortugalLocale = locale => locale === 'pt-pt';
export const isRomaniaLocale = locale => locale === 'ro-ro';
export const isRussiaLocale = locale => locale === 'ru-ru';
export const isCroatiaLocale = locale => locale === 'sr-sr';
export const isChinaSimplifiedLocale = locale => locale === 'zh-cn';
export const isChinaTraditionalLocale = locale => locale === 'zh-hk';
